import { SnackbarContent } from "@mui/material";
import styled from "styled-components";
import { ToastDisplayType } from "./MuiToast";
import { COLORS } from "../../styles/constants.style";

export const ToastWrapper = styled.div`
  .message-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 26px 32px 26px 42px;
    align-items: center;
  }

  .inline-message-container {
    padding: 14px 26px;
  }

  .message {
    padding-left: 22px;
    color: ${COLORS.cirrus_white};
  }
`;

export const StyledSnackbarContent = styled(SnackbarContent)<{
  type: ToastDisplayType;
}>`
  &.custom-snackbar {
    background-color: ${COLORS.cirrus_black8};
    .MuiSnackbarContent-message {
      padding: 0px;
    }
    padding: 0px;
    border-radius: 8px;
    color: ${COLORS.cirrus_white};
  }

  &.inline-message-snackbar {
    min-width: unset;
  }

  .check-image {
    color: ${COLORS.cirrus_white};
  }
`;
